<template>
  <div>
    <SimpleFieldList
      :disabled="disabled"
      :operators="operators"
      :spr="tenderContactPersons"
      :value.sync="mutableValue"/>
  </div>
</template>
<script>
import SimpleFieldList from 'components/automation/conditions/default/simpleFieldList.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()
/**
 * 3
 */
export default {
  name: 'tenderContact',
  computed: {
    tenderContactPersons() {
      return this.$store.getters.getTenderContactPersons.map(i => ({
        key: i.contactId,
        label: i.name,
        description: i.login
      }))
        .sort((a,b) => a.label?.localeCompare(b.label))
    },
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleFieldList
  },
  created() {
    if (!this.tenderContactPersons?.length) {
      tender_api.tenderContactPersons()
    }
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
